import * as React from "react";
const SvgFiRrRepublican = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-republican_svg__a)">
      <path
        fill="#062147"
        d="M23 17a1 1 0 0 0-1 1v1.001A1 1 0 0 1 20.002 19l.012-10.993a5.97 5.97 0 0 0-1.755-4.247A5.96 5.96 0 0 0 14.014 2H6C2.691 2 0 4.691 0 8v11.003A3.003 3.003 0 0 0 6.007 19h4.02a2.97 2.97 0 0 0 .873 2.121A3.001 3.001 0 0 0 16.021 19h1.98q0 .042.003.085c.021.769.33 1.488.876 2.035a2.98 2.98 0 0 0 2.122.88 3.003 3.003 0 0 0 2.999-2.999V18A1 1 0 0 0 23 17M6 4h8.014c1.069 0 2.074.417 2.83 1.173a3.98 3.98 0 0 1 1.17 2.832L18.01 12H2V8c0-2.206 1.794-4 4-4m10.02 13c-1.103 0-2 .897-2 2.003a1 1 0 0 1-1.704.706.99.99 0 0 1-.289-.703 2 2 0 0 0-.584-1.418A1.99 1.99 0 0 0 10.027 17H6.006a2.007 2.007 0 0 0-2 2.007 1 1 0 0 1-1.01.993 1 1 0 0 1-.997-.997V14h16.009l-.003 3zM9 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0M5 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0m8 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-republican_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRepublican;
